import React from "react";
import { ShieldCheck, Users, Scale } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  title: "Highspeed WLAN",
  description: "Schnelles Internet für ruckelfreie Videocalls. Sicher, stabil und verdammt schnell für all deine Projekte.",
  icon: ShieldCheck
}, {
  title: "Kaffee-Flatrate",
  description: "Frisch gerösteter Kaffee, Wasser und Tee inklusive. Deine Energiequelle für den ganzen Tag an unserer Bar.",
  icon: Users
}, {
  title: "Community Spirit",
  description: "Arbeite unter Gleichgesinnten in entspannter Atmosphäre. Networking und Austausch gibt's bei uns gratis dazu.",
  icon: Scale
}];
export default function OurValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}